export default __webpack_public_path__ + "static/29_31-7be494a341e4280e12686c0cac15e4d3.png";